import { assessmentMeasurementChangeSchema } from './assessment-measurement-change.js';
import { z } from 'zod';
import { IllegalArgumentError } from 'faro-common-model';
export var AssessmentMeasurementChangeOptions;
(function (AssessmentMeasurementChangeOptions) {
    AssessmentMeasurementChangeOptions["ADDED"] = "Added";
    AssessmentMeasurementChangeOptions["UPDATED"] = "Updated";
    AssessmentMeasurementChangeOptions["DELETED"] = "Deleted";
})(AssessmentMeasurementChangeOptions || (AssessmentMeasurementChangeOptions = {}));
export const assessmentMeasurementUpdateDetailSchema = z.object({
    name: z.string(),
    version: z.number(),
    updateType: z.enum(AssessmentMeasurementChangeOptions),
    changes: z.array(assessmentMeasurementChangeSchema),
});
export function toAssessmentMeasurementUpdateDetail(updateDetail) {
    const result = assessmentMeasurementUpdateDetailSchema.safeParse(updateDetail);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid AssessmentMeasurementUpdateDetail object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=assessment-measurement-update-detail.js.map